module.exports = __webpack_public_path__ + "static/media/success3.d2c28fdc.png";